<template>
  <div class="summary">
    <div class="summary__header">
      Resumo do Pedido
      <span>
        {{ formatedDate }}
      </span>
    </div>
    <ul class="summary__list-data">
      <li class="summary__item">
        <span class="label">
          Valor
        </span>
        <span class="value">
          R$ {{ convertValueToMoney(summaryData.value) }}
        </span>
      </li>
      <li class="summary__item">
        <span class="label">
          Forma de Pagamento
        </span>
        <span class="value">
          {{ summaryData.paymentMethod }}
        </span>
      </li>
      <li class="summary__item">
        <span class="label">
          Total
        </span>
        <span class="value">
          R$ {{ convertValueToMoney(summaryData.total) }}
        </span>
      </li>
    </ul>
    <div class="summary__code">
      <span class="label">
        Código da transação
      </span>
      <span>
        {{ summaryData.txId }}
      </span>
    </div>
  </div>
</template>

<script>
import { formatPrice } from '@/utils/formatPrice'
import { formatDate } from '@/utils/date-utils';

export default {
  name: 'PaymentProofModal',
  props: {
    summaryData: {
      required: true,
      type: Object
    }
  },
  data() {
    return {}
  },
  computed: {
    formatedDate() {
      return formatDate(this.summaryData.datePayment, 4)
    }
  },
  methods: {
    convertValueToMoney(value){
      return formatPrice(value)
    }
  }
}
</script>

<style lang="scss">
  .summary {
    padding: 24px;
    background-color: rgba(22, 22, 22, 0.04);
    border-radius: 6px;
    min-width: 330px;
    max-width: 442px;
    width: 100%;

    &__header {
      display: flex;
      justify-content: space-between;
      font-weight: 600;
      border-bottom: 2px solid #4A4A4A;
      color: #4A4A4A;
    }

    &__item {
      padding-top: 12px;
      display: flex;
      justify-content: space-between;

      .label {
        font-weight: 600;
      }

      &:last-child {
        border-top: 1px solid #979797;
      }
    }

    &__code {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 24px;

      .label {
        font-weight: 600;
      }
    }
  }
</style>
